import JournalModel from './journal';
import EventModel from './event';
import PollModel from './poll';

import { formatDistanceToNow } from 'date-fns';
import { localeDate } from '@/plugins/date-print';
import { ru } from 'date-fns/locale';

const STATUS_TYPES = {
  completed: 1,
  waiting: 2,
  uncompleted: 3,
};

const STATUS_TYPES_DATA = (ctx) => ({
  [STATUS_TYPES.completed]: {
    id: STATUS_TYPES.completed,
    name: 'Оценено мной',
    icon: '$icheck-outline-circle',
    color: 'redesignSuccess',
  },
  [STATUS_TYPES.waiting]: {
    id: STATUS_TYPES.waiting,
    name: `Ожидает оценки ${ctx.waitingDate}`,
    icon: '$iclock-outline',
    color: 'warning',
  },
  [STATUS_TYPES.uncompleted]: {
    id: STATUS_TYPES.uncompleted,
    name: 'Не завершено участником',
    icon: '$iedit',
    color: 'redesignError',
  },
});

export default class JournalExpertise extends JournalModel {
  constructor(journal, url) {
    super(journal, url);

    this.event = new EventModel(journal?.event || {});
    this.poll = new PollModel(journal?.poll || {});
    this.owner = journal?.owner || null;
    this.is_fire = journal.is_fire || false;
    this.maximum_expertises = journal?.maximum_expertises || null;
  }

  get status() {
    const statusTypeData = STATUS_TYPES_DATA(this);

    if (this.has_own_completed_expertise) {
      return statusTypeData[STATUS_TYPES.completed];
    }

    if (!this.isFinished) {
      return statusTypeData[STATUS_TYPES.uncompleted];
    }

    return statusTypeData[STATUS_TYPES.waiting];
  }

  get waitingDate() {
    const formatedStartDate = localeDate(new Date(this.finished_at));
    const timePassed = formatDistanceToNow(formatedStartDate, {
      locale: ru,
    });
    return timePassed;
  }

  get canGrade() {
    return this.status.id === STATUS_TYPES.waiting;
  }
}
